import React, { Component } from 'react'
import {Button, Header, Icon, Modal} from 'semantic-ui-react'

export default class ConfirmModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalOpen: false
        }

        this.handleOpen = this.handleOpen.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    handleOpen() {
        this.setState({modalOpen: true})
    }

    handleClose() {
        this.setState({modalOpen: false})
    }

    render() {
        const { header, content, confirm, buttonText } = this.props
        return (
            <Modal
                trigger={<div onClick={this.handleOpen}>{buttonText}</div>}
                open={this.state.modalOpen}
                onClose={this.handleClose}
                size="tiny"
            >
                <Header content={header}/>
                <Modal.Content>
                    <p>
                        {content}
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.handleClose}>
                        <Icon name='remove'/> No
                    </Button>
                    <Button onClick={confirm}>
                        <Icon name='checkmark'/> Yes
                    </Button>
                </Modal.Actions>
            </Modal>
        )

    }
}



// WEBPACK FOOTER //
// ./source/containers/Surveys/Sidebar/ConfirmModal.jsx